import { merge } from 'ramda';
import {
  type Snmp,
  type SnmpCommandFactory,
  prepareDataForSnmpForm,
} from '../SnmpModel';
import { patchSnmp } from './api/patchSnmp';

type SaveSnmpCommand = {
  values: Snmp;
};

export const saveSnmp: SnmpCommandFactory<SaveSnmpCommand> =
  (cmdContext) => async (command) => {
    cmdContext.updateState((draft) => {
      draft.submitting = true;
    });
    const {
      enabled,
      version,
      hostIp,
      locality = null,
      systemContact = null,
      communityString = undefined,
      username,
      passphrase,
      encryptionPassphrase,
      authenticationType,
    } = command.values;

    const getData = () => {
      if (!enabled) {
        return { enabled: false };
      }

      const commonFields = {
        enabled,
        version,
        hostIp,
        locality: locality === '' ? null : locality,
        systemContact: systemContact === '' ? null : systemContact,
      };

      const versionSpecificFields =
        version === '2c'
          ? { communityString }
          : {
              username,
              passphrase,
              authenticationType,
              ...(encryptionPassphrase && { encryptionPassphrase }),
            };

      return merge(versionSpecificFields)(commonFields);
    };
    const response = await patchSnmp(cmdContext.api, getData());
    const data = prepareDataForSnmpForm(response.snmp);
    cmdContext.updateState((draft) => {
      draft.values = data;
      draft.submitting = false;
    });
    cmdContext.showNotification({
      type: 'success',
      message: 'SNMP settings saved successfully',
      title: 'Success',
    });
  };
